import {
  ChildApplyEntity,
} from './childApplyEntity';
import { Address } from './valueObjects/address';
import { ApplyDateTime } from './valueObjects/applyDateTime';
import { ApplyStatus } from './valueObjects/applyStatus';
import { Birthday } from './valueObjects/birthday';
import { ChildFamilyName } from './valueObjects/childFamilyName';
import { ChildFamilyNameKana } from './valueObjects/childFamilyNameKana';
import { ChildId } from './valueObjects/childId';
import { ChildName } from './valueObjects/childName';
import { ChildNameKana } from './valueObjects/childNameKana';
import { Email } from './valueObjects/email';
import { FacilityId } from './valueObjects/facilityId';
import { FacilityName } from './valueObjects/facilityName';
import { Gender } from './valueObjects/gender';
import { ParentFamilyName } from './valueObjects/parentFamilyName';
import { ParentFamilyNameKana } from './valueObjects/parentFamilyNameKana';
import { ParentId } from './valueObjects/parentId';
import { ParentName } from './valueObjects/parentName';
import { ParentNameKana } from './valueObjects/parentNameKana';
import { PostalCode } from './valueObjects/postalCode';
import { Tel } from './valueObjects/tel';

import type {
  ChildApplyPropsPub,
  ChildApplyPropsPvt,
} from './childApplyEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { ChildApplyJsonPub, ChildApplyJsonPvt } from '@/types/domain/childApply/entities/childApplyEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class ChildApplyFactory extends FactoryPub<
  ChildApplyEntity,
  ChildApplyPropsPvt,
  ChildApplyJsonPvt,
  ChildApplyPropsPub,
  ChildApplyJsonPub
> {
  comparePub = (
    a: EntityDataPubType<ChildApplyJsonPvt, ChildApplyJsonPub>,
    b: EntityDataPubType<ChildApplyJsonPvt, ChildApplyJsonPub>,
  ) => a.data.childId.localeCompare(b.data.childId, 'en');

  create(
    props: ChildApplyPropsPvt,
    propsPub: EntityPubNotNullType<ChildApplyPropsPub>,
  ): ChildApplyEntity {
    return new ChildApplyEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<ChildApplyJsonPvt, ChildApplyJsonPub>,
  ): ChildApplyEntity {
    return this.create({
      childId: ChildId.create(props.data.childId),
      facilityId: FacilityId.create(props.data.facilityId),
      facilityName: FacilityName.create(props.data.facilityName),
      childName: ChildName.create(props.data.childName),
      childFamilyName: ChildFamilyName.create(props.data.childFamilyName),
      childNameKana: ChildNameKana.create(props.data.childNameKana),
      childFamilyNameKana: ChildFamilyNameKana.create(props.data.childFamilyNameKana),
      gender: Gender.create(props.data.gender),
      birthday: Birthday.create(new Date(props.data.birthday)),
      email: Email.create(props.data.email),
      parentId: ParentId.create(props.data.parentId),
      parentName: ParentName.create(props.data.parentName),
      parentFamilyName: ParentFamilyName.create(props.data.parentFamilyName),
      parentNameKana: ParentNameKana.create(props.data.parentNameKana),
      parentFamilyNameKana: ParentFamilyNameKana.create(props.data.parentFamilyNameKana),
      postalCode: PostalCode.create(props.data.postalCode),
      address: Address.create(props.data.address),
      tel: Tel.create(props.data.tel),
      applyDateTime: ApplyDateTime.create(new Date(props.data.applyDateTime)),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {
        applyStatus: ApplyStatus.create(props.pub.data.applyStatus),
      },
    });
  }
}
